import {
	AppBar,
	Dialog,
	IconButton,
	Toolbar,
	Typography,
	WithStyles,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import grey from '@material-ui/core/colors/grey';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Select from '@material-ui/core/Select';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import TextField from '@material-ui/core/TextField';
import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { IMessage } from '../actions/message';
import {
	IApply,
	IApprovalItem,
	IApprovalResult,
	IApprovalResultErrorMessage,
	IApprovalStayMealData,
	ICareerSearchCondition,
	openApprovalConfirm,
	openApprovals,
	openApprovalTargetCheck,
	setApprovalResult,
	setApprovals,
	setApprovalsSelectedColumns,
	setApprovalsSelectedColumnsForStayMeal,
	setApprovalStayMealList,
	setCanApproval,
	setClassStayMealDialog,
} from '../actions/search';
import MessageDialog from '../components/MessageDialog';
import ReactTable, { RowRenderProps } from '../components/MyReactTable';
import { IRootState } from '../reducers';
import i18next from '../resources/i18n';
import ScenarioFactory, {
	IApplyCareersParam,
	IStayMealSearchParam,
} from '../scenario/SearchScenarioFactory';
import { CMItemCode, isValid } from '../utils/CMData';
import InputCheck from '../utils/InputCheck';
import { isMobile } from '../utils/MobileCheck';

import CloseIcon from '@material-ui/icons/Close';
import CareerDetail from 'src/containers/CareerDetail';
import CareerStayMeal, { IStayMealdata } from 'src/containers/CareerStayMeal';
import CurriculumDetail from 'src/containers/CurriculumDetail';
import SkillDetail from 'src/containers/SkillDetail';
import { UpwardTransition } from 'src/utils';
import { getSystemMst, MasterItemCode } from '../utils/MasterData';
import CustomDatePicker from './CustomDatePicker';

const styles = (theme: Theme) =>
	createStyles({
		appBar: {
			position: 'relative',
		},
		button: {
			margin: '10px',
		},
		careerDialog: {
			width: '80%',
		},
		checkbox: {
			height: 36,
			width: 36,
		},
		column: {
			display: 'inline-block',
			textAlign: 'center',
			width: '33.33%',
		},
		flex: {
			flex: 1,
		},
		link: {
			color: 'blue',
			cursor: 'pointer',
		},
		mobileCellItemName: {
			alignItems: 'center',
			backgroundColor: grey[300],
			display: 'flex',
			minHeight: '40px',
			minWidth: '10px',
			paddingLeft: '5px',
			textAlign: 'left',
			whiteSpace: 'normal',
			width: '100%',
			wordBreak: 'break-all',
		},
		mobileCellItemValue: {
			alignItems: 'center',
			display: 'flex',
			minHeight: '40px',
			paddingLeft: '5px',
			textAlign: 'left',
			whiteSpace: 'normal',
			width: '100%',
			wordBreak: 'break-all',
		},
		mobileColumn: {
			display: 'inline-block',
			textAlign: 'center',
			width: '100%',
		},
		mobileFlex: {
			flex: 1,
			fontSize: '16px',
		},
		mobileTextPeriod: {
			display: 'flex',
			justifyContent: 'center',
		},
		mobileWrapDiv: {
			margin: '2px',
		},
		pointer: {
			cursor: 'pointer',
		},
		root: {
			flexGrow: 1,
			marginTop: '12px',
			padding: 24,
		},
		scrollPaper: {
			alignItems: 'flex-start',
		},
		textArea: {
			width: '100%',
		},
		textDate: {
			width: 200,
		},
		textPeriod: {
			display: 'flex',
			justifyContent: 'center',
			marginLeft: '10px',
		},
		whiteSpace: {
			whiteSpace: 'normal',
		},
		whiteSpaceMenuItem: {
			whiteSpace: 'normal',
			'word-break': 'break-all',
		},
		wrapDiv: {
			margin: '10px',
		},
	});

export interface IApprovalsProps {
	caller: string;
}

const EMPTY_APPROVER_SELECT = '---';

interface IState {
	initFlag: boolean;
	errorDialogOpen: boolean;
	errorDialogContent: string;
	errorDialogReplacements: string[];
	selectColumnsMenuAnchorEl?: HTMLElement;
	reason: string;
	fetchedCanApprovalMessage: boolean;
	openCareerDetailDialog: boolean;
	openCurriculumDetailDialog: boolean;
	openSkillDetailDialog: boolean;
	careerID: string;
	stayMealData: IStayMealdata;
	startDate: string[];
	endDate: string[];
	classIds: string[];
	errorsDialogOpen: boolean;
	dialogContent: IMessage[];
}

/**
 * 受講申請
 */
class Approvals extends React.Component<IProps, IState> {
	public constructor(props: IProps) {
		super(props);

		this.state = {
			careerID: '',
			classIds: [],
			dialogContent: [],
			endDate: [],
			errorDialogContent: '',
			errorDialogOpen: false,
			errorDialogReplacements: [],
			errorsDialogOpen: false,
			fetchedCanApprovalMessage: false,
			initFlag: false,
			openCurriculumDetailDialog: false,
			reason: '',

			openCareerDetailDialog: false,
			openSkillDetailDialog: false,
			startDate: [],
			stayMealData: {
				careerID: '',
				classId: '',
				dayMealAfternoon: '0',
				dayMealEvening: '0',
				dayMealMorning: '0',
				dayStay: '0',
				postMealAfternoon: '0',
				postMealEvening: '0',
				postMealMorning: '0',
				preMealAfternoon: '0',
				preMealEvening: '0',
				preMealMorning: '0',
				preStay: '0',
				sex: '0',
				smoking: '0',
			},
		};
		this.openConfirmDialog = this.openConfirmDialog.bind(this);
		this.closeConfirmDialog = this.closeConfirmDialog.bind(this);
		this.closeErrorDialog = this.closeErrorDialog.bind(this);
		this.closeDialog = this.closeDialog.bind(this);
		this.onClickCancel = this.onClickCancel.bind(this);
		this.onChangeApprover = this.onChangeApprover.bind(this);
		this.onChangeReason = this.onChangeReason.bind(this);
		this.applyCareers = this.applyCareers.bind(this);
		this.closeApprovalResultDialog = this.closeApprovalResultDialog.bind(
			this
		);
		this.okApprovalResultDialog = this.okApprovalResultDialog.bind(this);
		this.okCanApproval = this.okCanApproval.bind(this);
		this.closeCanApproval = this.closeCanApproval.bind(this);
		this.getParams = this.getParams.bind(this);
		this.handleChangeStartDate = this.handleChangeStartDate.bind(this);
		this.handleChangeEndDate = this.handleChangeEndDate.bind(this);
		this.getDatePicker = this.getDatePicker.bind(this);
		this.getType = this.getType.bind(this);
		this.getApproverId1 = this.getApproverId1.bind(this);
		this.getApproverId2 = this.getApproverId2.bind(this);
		this.getApproverId4 = this.getApproverId4.bind(this);
	}

	public componentDidMount() {
		this.setState({ initFlag: false });
	}

	public componentDidUpdate() {
		const endDates: string[] = [];
		const startDates: string[] = [];
		if (this.props.data.length > 0 && this.state.initFlag === false) {
			const classIds = [];
			for (const row of this.props.data) {
				classIds.push(row.classId);
				const s = this.getDateFromStr(row.startDate);
				const e = this.getDateFromStr(row.endDate);
				if (
					row.startDate != null &&
					row.startDate !== undefined &&
					row.startDate !== ''
				) {
					if (row.startDate.length < 16) {
						startDates.push('');
					} else {
						startDates.push(s);
					}
				} else {
					startDates.push('');
				}

				if (
					row.endDate != null &&
					row.endDate !== undefined &&
					row.endDate !== ''
				) {
					if (row.endDate.length < 16) {
						endDates.push('');
					} else {
						endDates.push(e);
					}
				} else {
					endDates.push('');
				}
			}

			// set default selected approvers for each class
			const newApprovals = Object.assign(
				[],
				this.props.data
			) as IApprovalItem[];
			this.props.data.forEach((clazz, index) => {
				const defaultApprover1 =
					clazz.approverList1 &&
					clazz.approverList1[0] &&
					clazz.approverList1[0].id;
				const defaultApprover2 =
					clazz.approverList2 &&
					clazz.approverList2[0] &&
					clazz.approverList2[0].id;
				const defaultApprover4 =
					clazz.approverList4 &&
					clazz.approverList4[0] &&
					clazz.approverList4[0].id;

				if (defaultApprover1) {
					newApprovals[index].approverId1 = defaultApprover1;
				}

				if (defaultApprover2) {
					newApprovals[index].approverId2 = defaultApprover2;
				}

				if (defaultApprover4) {
					newApprovals[index].approverId4 = defaultApprover4;
				}
			});
			this.props.setApprovals(newApprovals);

			this.setState({
				classIds,
				endDate: endDates,
				initFlag: true,
				startDate: startDates,
			});
		}
	}

	public componentWillUnmount() {
		this.props.setApprovalStayMealList([]);
	}

	public render() {
		const { classes, data } = this.props;
		const columns = this.getSelectedColumns();
		const mobileColumns = this.getSelectedMobileColumns();

		const dialogOpen: boolean =
			this.props.isOpenApprovalConfirm ||
			this.state.errorDialogOpen ||
			this.props.isOpenApprovalResult ||
			this.props.isOpenCanApproval ||
			this.state.errorsDialogOpen;
		let showCancel: boolean = false;
		let dialogTitle: string = '';
		let dialogContent: IMessage[] = [];
		let onDialogClose: () => void;
		let onDialogOk: () => void;

		// 登録確認ダイアログで初期化
		showCancel = true;
		dialogTitle = i18next.t('Approvals_0001');
		dialogContent = [{ content: 'LMCM_C_00510' }];
		onDialogClose = this.closeConfirmDialog;
		onDialogOk = this.applyCareers;
		if (this.state.errorsDialogOpen) {
			showCancel = false;
			dialogTitle = i18next.t('Approvals_0002');
			dialogContent = this.state.dialogContent;
			onDialogClose = this.closeErrorDialog;
			onDialogOk = this.closeErrorDialog;
		} else if (this.state.errorDialogOpen) {
			// 入力エラー時
			showCancel = false;
			dialogTitle = i18next.t('Approvals_0002');
			dialogContent = [
				{
					content: this.state.errorDialogContent,
					replacements: this.state.errorDialogReplacements,
				},
			];
			onDialogClose = this.closeErrorDialog;
			onDialogOk = this.closeErrorDialog;
		} else if (this.props.isOpenApprovalResult) {
			// サーバメッセージ
			showCancel = false;
			dialogTitle = this.props.approvalResult.success
				? i18next.t('Approvals_0003')
				: i18next.t('Approvals_0002');
			dialogContent = this.props.approvalResult.success
				? [{ content: 'LMCM_I_00418' }]
				: this.props.approvalResult.errorMessageList.map(
						(message: IApprovalResultErrorMessage): IMessage => ({
							content: message.messageId,
							replacements: message.replacementStringList,
						})
				  );

			if (this.props.data[0].careerTypeId === 10) {
				dialogContent = this.props.approvalResult.success
					? [{ content: 'LMCM_I_00861' }]
					: this.props.approvalResult.errorMessageList.map(
							(
								message: IApprovalResultErrorMessage
							): IMessage => ({
								content: message.messageId,
								replacements: message.replacementStringList,
							})
					  );
			}
			onDialogClose = this.closeApprovalResultDialog;
			// tslint:disable-next-line: prettier
			if (this.props.approvalResult.success) {
				onDialogOk = this.okApprovalResultDialog;
			} else {
				onDialogOk = this.closeApprovalResultDialog;
			}
		} else if (this.props.isOpenCanApproval) {
			// 申請前メッセージ（定員チェック）
			dialogTitle = i18next.t('Approvals_0002');
			dialogContent = [
				{
					content: this.props.canApproval.messageId,
					replacements: this.props.canApproval.replacementStringList,
				},
			];
			onDialogClose = this.closeCanApproval;
			onDialogOk = this.okCanApproval;
		}

		const selected = this.props.data.filter(item => item.check === '')
			.length;
		const indicator = selected
			? `${selected}${i18next.t('Approvals_0004')}`
			: '';
		return (
			<Paper className={classes.root}>
				{!isMobile() && (
					<>
						<div className={classes.wrapDiv}>
							<ReactTable
								data={data}
								columns={columns}
								defaultPageSize={10}
								className="-striped -highlight"
								columnsMenu={true}
								menuHandler={this.handleSelectColumns}
								indicator={indicator}
							/>
						</div>
						{this.getSelectColumnsMenu()}
					</>
				)}
				{isMobile() && (
					<>
						<div className={classes.mobileWrapDiv}>
							<ReactTable
								data={data}
								columns={mobileColumns}
								defaultPageSize={10}
								className="-striped -highlight"
								indicator={indicator}
							/>
						</div>
					</>
				)}

				{!isMobile() && (
					<>
						<div className={classes.column} />
						<div className={classes.column}>
							<TextField
								id="multiline-flexible"
								className={classes.textArea}
								label={i18next.t('Approvals_0005')}
								multiline={true}
								rows="4"
								margin="normal"
								value={this.state.reason}
								onChange={this.onChangeReason}
							/>
						</div>
						<div className={classes.column} />
					</>
				)}
				{isMobile() && (
					<>
						<div className={classes.mobileColumn}>
							<TextField
								id="multiline-flexible"
								className={classes.textArea}
								label={i18next.t('Approvals_0005')}
								multiline={true}
								rows="4"
								margin="normal"
								value={this.state.reason}
								onChange={this.onChangeReason}
							/>
						</div>
					</>
				)}

				<>
					<div className={classes.mobileColumn}>
						<Button
							variant="contained"
							color="primary"
							onClick={this.openConfirmDialog}
						>
							{i18next.t('Approvals_0006')}
						</Button>
					</div>
				</>
				<MessageDialog
					open={dialogOpen}
					showCancelButton={showCancel}
					title={dialogTitle}
					contents={dialogContent}
					onClose={onDialogClose}
					onClickOk={onDialogOk}
				/>
				<Dialog
					fullScreen={false}
					TransitionComponent={UpwardTransition}
					open={this.state.openCareerDetailDialog}
					onClose={this.handlecloseDetailDialog}
					fullWidth={true}
					maxWidth={false}
					classes={{
						paperFullWidth: this.props.classes.careerDialog,
					}}
				>
					<AppBar className={this.props.classes.appBar}>
						<Toolbar>
							<IconButton
								color="inherit"
								aria-label="Close"
								onClick={this.handlecloseDetailDialog}
							>
								<CloseIcon />
							</IconButton>
							<Typography variant="h6" color="inherit">
								{i18next.t('Approvals_0007')}
							</Typography>
						</Toolbar>
					</AppBar>
					<CareerDetail careerID={this.state.careerID} />
				</Dialog>
				<Dialog
					fullScreen={false}
					TransitionComponent={UpwardTransition}
					open={this.state.openCurriculumDetailDialog}
					onClose={this.handlecloseDetailDialog}
					fullWidth={true}
					maxWidth={false}
					classes={{
						paperFullWidth: this.props.classes.careerDialog,
					}}
				>
					<AppBar className={this.props.classes.appBar}>
						<Toolbar>
							<IconButton
								color="inherit"
								aria-label="Close"
								onClick={this.handlecloseDetailDialog}
							>
								<CloseIcon />
							</IconButton>
							<Typography variant="h6" color="inherit">
								{i18next.t('Approvals_0008')}
							</Typography>
						</Toolbar>
					</AppBar>
					<CurriculumDetail curriculumId={this.state.careerID} />
				</Dialog>
				<Dialog
					fullScreen={false}
					TransitionComponent={UpwardTransition}
					open={this.state.openSkillDetailDialog}
					onClose={this.handlecloseDetailDialog}
					fullWidth={true}
					maxWidth={false}
					classes={{
						paperFullWidth: this.props.classes.careerDialog,
					}}
				>
					<AppBar className={this.props.classes.appBar}>
						<Toolbar>
							<IconButton
								color="inherit"
								aria-label="Close"
								onClick={this.handlecloseDetailDialog}
							>
								<CloseIcon />
							</IconButton>
							<Typography variant="h6" color="inherit">
								{i18next.t('Approvals_0009')}
							</Typography>
						</Toolbar>
					</AppBar>
					<SkillDetail skillId={this.state.careerID} />
				</Dialog>
				<Dialog
					fullScreen={false}
					TransitionComponent={UpwardTransition}
					open={this.props.classStayMealDialog}
					onClose={this.handlecloseStayMealDialog}
					fullWidth={true}
					maxWidth={false}
					classes={{
						paperFullWidth: this.props.classes.careerDialog,
						scrollPaper: this.props.classes.scrollPaper,
					}}
				>
					<AppBar className={this.props.classes.appBar}>
						<Toolbar>
							<IconButton
								color="inherit"
								aria-label="Close"
								onClick={this.handlecloseStayMealDialog}
							>
								<CloseIcon />
							</IconButton>
							<Typography variant="h6" color="inherit">
								{i18next.t('Approvals_0010')}
							</Typography>
						</Toolbar>
					</AppBar>
					<CareerStayMeal
						StayMealdata={this.state.stayMealData}
						comment={''}
					/>
				</Dialog>
			</Paper>
		);
	}

	protected handleShowDetailDialog = (
		event: React.MouseEvent<HTMLElement>
	) => {
		const careerId = event.currentTarget.getAttribute('data-careerid');
		const careerType = event.currentTarget.getAttribute('data-careertype');
		if (careerId && careerId !== '' && careerType && careerType !== '') {
			if (careerType === '0') {
				this.setState({
					careerID: careerId,
					openCareerDetailDialog: true,
				});
			} else if (careerType === '10') {
				this.setState({
					careerID: careerId,
					openSkillDetailDialog: true,
				});
			} else if (careerType === '90') {
				this.setState({
					careerID: careerId,
					openCurriculumDetailDialog: true,
				});
			}
		}
	};

	protected handlecloseDetailDialog = () => {
		this.setState({
			careerID: '',
			openCareerDetailDialog: false,
			openCurriculumDetailDialog: false,
			openSkillDetailDialog: false,
		});
	};

	protected handlecloseStayMealDialog = () => {
		this.props.setClassStayMealDialog(false);
	};

	/**
	 * 申請前ダイアログOKボタン
	 */
	protected okCanApproval() {
		// ダイアログを閉じて確認ダイアログを表示
		this.props.closeCanApproval();
		this.props.openApprovalConfirm(true);
	}

	/**
	 * 申請前ダイアログクローズ
	 */
	protected closeCanApproval() {
		// 検索終了
		this.setState({
			fetchedCanApprovalMessage: false,
		});
		// ダイアログを閉じる
		this.props.closeCanApproval();
	}

	/**
	 * 申請結果表示ダイアログクローズ
	 */
	protected closeApprovalResultDialog() {
		this.props.setApprovalResult(
			{
				errorMessageList: [],
				exceptionEndFlg: 0,
				success: true,
			},
			false
		);
	}

	/**
	 * 申請結果表示ダイアログOKボタン
	 */
	protected okApprovalResultDialog() {
		this.setState({
			reason: '',
		});
		// ダイアログクローズ
		this.props.setApprovalResult(
			{
				errorMessageList: [],
				exceptionEndFlg: 0,
				success: true,
			},
			false
		);
		this.props.openApprovals(false);
		this.props.openApprovalTargetCheck(false);
		// 再検索
		this.props.fetchCategoryCareerTree(this.props.token);
		this.props.fetchDetailCareerList(
			this.props.token,
			this.props.searchCondition
		);
		this.props.setApprovalStayMealList([]);
		// 前の画面に戻る
		this.props.pushHistory(this.props.caller);
	}

	/**
	 * 確認ダイアログオープン
	 */
	protected openConfirmDialog() {
		const { reason } = this.state;

		const selectable = this.props.data.filter(item => item.check === '');
		const cmFlg: boolean = isValid(CMItemCode.CM_ENABLED);

		if (selectable.length === 0) {
			if (isMobile()) {
				this.setState({
					errorDialogContent: 'LMCM_E_00235',
					errorDialogOpen: true,
					errorDialogReplacements: [i18next.t('Approvals_0011')],
				});
				return;
			} else {
				this.setState({
					errorDialogContent: cmFlg ? 'LMCM_E_15014' : 'LMCM_E_00235',
					errorDialogOpen: true,
					errorDialogReplacements: cmFlg
						? []
						: [i18next.t('Approvals_0011')],
				});
				return;
			}
		}
		// 入力チェック
		if (reason && reason.length > 200) {
			this.setState({
				errorDialogContent: 'CHK_E_0004',
				errorDialogOpen: true,
				errorDialogReplacements: [i18next.t('Approvals_0005'), '200'],
			});
			return;
		}

		// 実施期間入力チェック
		const messageList: IMessage[] = [];
		for (const item of selectable) {
			if (item.careerTypeId === 10) {
				const classId = item.classId;
				if (classId === 'CL000000') {
					const nstartDate = item.startDate;
					const nendDate = item.endDate;
					if (nstartDate) {
						if (
							InputCheck.chkErYYYYMMDDhhmm(
								InputCheck.convertDate(nstartDate)
							)
						) {
							const message: IMessage = {
								content: 'LMCM_E_15016',
								replacements: [
									item.careerTitle,
									i18next.t('Approvals_0012'),
								],
							};
							messageList.push(message);
						}
						if (
							!InputCheck.chkErYYYYMMDDhhmm(
								InputCheck.convertDate(nstartDate)
							) &&
							(nstartDate < '1900/01/01 00:00' ||
								nstartDate > '2100/01/01 23:59')
						) {
							const message: IMessage = {
								content: 'LMCM_E_15016',
								replacements: [
									item.careerTitle,
									i18next.t('Approvals_0012'),
								],
							};
							messageList.push(message);
						}
					} else {
						const message: IMessage = {
							content: 'LMCM_E_15015',
							replacements: [
								item.careerTitle,
								i18next.t('Approvals_0012'),
							],
						};
						messageList.push(message);
					}

					if (nendDate) {
						if (
							InputCheck.chkErYYYYMMDDhhmm(
								InputCheck.convertDate(nendDate)
							) &&
							(nstartDate < '1900/01/01 00:00' ||
								nstartDate > '2100/01/01 23:59')
						) {
							const message: IMessage = {
								content: 'LMCM_E_15016',
								replacements: [
									item.careerTitle,
									i18next.t('Approvals_0013'),
								],
							};
							messageList.push(message);
						}
						if (
							!InputCheck.chkErYYYYMMDDhhmm(
								InputCheck.convertDate(nendDate)
							) &&
							(nendDate < '1900/01/01 00:00' ||
								nendDate > '2100/01/01 23:59')
						) {
							const message: IMessage = {
								content: 'LMCM_E_15016',
								replacements: [
									item.careerTitle,
									i18next.t('Approvals_0012'),
								],
							};
							messageList.push(message);
						}
					} else {
						const message: IMessage = {
							content: 'LMCM_E_15015',
							replacements: [
								item.careerTitle,
								i18next.t('Approvals_0013'),
							],
						};
						messageList.push(message);
					}
					if (nstartDate && nendDate) {
						if (
							InputCheck.chkFuturePast(nstartDate, nendDate) === 1
						) {
							const message: IMessage = {
								content: 'LMCM_E_15017',
								replacements: [item.careerTitle],
							};
							messageList.push(message);
						}
					}
				}
			}
		}
		if (messageList.length > 0) {
			this.setState({
				dialogContent: messageList,
				errorsDialogOpen: true,
			});
			return;
		}

		let cancelWaitCount = 0;
		this.props.data.map((approval: IApprovalItem) => {
			if (null !== approval.cancel && approval.classId !== 'CL000000') {
				cancelWaitCount++;
			}
		});
		if (cancelWaitCount === 0) {
			// キャンセル待ちが無ければ確認ダイアログを表示
			this.props.openApprovalConfirm(true);
		} else if (cancelWaitCount === 1) {
			// 検索中とする
			this.setState({
				fetchedCanApprovalMessage: true,
			});
			// キャンセル待ちが1件であれば、サーバよりメッセージ取得
			const params = this.getParams();
			this.props.fetchCanApproval(this.props.token, params);
		} else {
			// キャンセル待ちが複数であればエラーメッセージ
			this.setState({
				errorDialogContent: 'LMCM_E_00611',
				errorDialogOpen: true,
				errorDialogReplacements: [],
			});
		}
	}

	/**
	 * 確認ダイアログクローズ
	 */
	protected closeConfirmDialog() {
		this.props.openApprovalConfirm(false);
	}

	/**
	 * 確認ダイアログクローズ
	 */
	protected closeErrorDialog() {
		this.setState({ errorDialogOpen: false, errorsDialogOpen: false });
	}

	protected check = (event: React.MouseEvent<HTMLElement>) => {
		const newApprovals = Object.assign([], this.props.data);
		const index = event.currentTarget.getAttribute('data-index');
		if (index && index !== '') {
			if (newApprovals[index].check === '') {
				newApprovals[index].check = 'uncheck';
			} else {
				newApprovals[index].check = '';
			}
			this.props.setApprovals(newApprovals);
		}
	};

	protected checkAll = (event: React.MouseEvent<HTMLElement>) => {
		const newApprovals: IApprovalItem[] = Object.assign(
			[],
			this.props.data
		);
		const selectable = this.props.data.filter(item => item.check === '');
		const checked =
			selectable.length !== 0 &&
			selectable.length === this.props.data.length;
		// tslint:disable-next-line: prefer-for-of
		for (let index = 0; index < newApprovals.length; index++) {
			if (checked) {
				newApprovals[index].check = 'uncheck';
			} else {
				newApprovals[index].check = '';
			}
			this.props.setApprovals(newApprovals);
		}
	};

	protected handleOpenStayMealDialog = (row: RowRenderProps) => (
		event: React.MouseEvent<HTMLElement>
	) => {
		const stayMealDataTemp: IStayMealdata = {
			careerID: row.original.careerId,
			classId: row.original.classId,
			dayMealAfternoon: row.original.dayMealAfternoon,
			dayMealEvening: row.original.dayMealEvening,
			dayMealMorning: row.original.dayMealMorning,
			dayStay: row.original.dayStay,
			postMealAfternoon: row.original.postMealAfternoon,
			postMealEvening: row.original.postMealEvening,
			postMealMorning: row.original.postMealMorning,
			preMealAfternoon: row.original.preMealAfternoon,
			preMealEvening: row.original.preMealEvening,
			preMealMorning: row.original.preMealMorning,
			preStay: row.original.preStay,
			sex: row.original.sex,
			smoking: row.original.smoking,
		};
		const param: IStayMealSearchParam = {
			careerId: row.original.careerId,
			classId: row.original.classId,
		};
		this.props.fetchStayMealDateList(this.props.token, param);
		this.setState({
			stayMealData: stayMealDataTemp,
		});
		this.props.setClassStayMealDialog(true);
	};

	protected getAllMobileColumns() {
		const { classes } = this.props;
		const careerTypeControl = getSystemMst(
			MasterItemCode.CAREER_TYPE_CONTROL
		);
		return [
			{
				Cell: (row: RowRenderProps) => {
					return (
						<>
							<Paper>
								<div>
									<div className={classes.mobileCellItemName}>
										{i18next.t('Approvals_0037')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{row.original.check !== null && (
											<Checkbox
												className={
													this.props.classes.checkbox
												}
												data-index={row.index}
												checked={
													row.original.check === ''
														? true
														: false
												}
												onClick={this.check}
											/>
										)}
									</div>
									<div className={classes.mobileCellItemName}>
										{i18next.t('Approvals_0014')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{row.original.managementCode}
									</div>
									<div className={classes.mobileCellItemName}>
										{i18next.t('Approvals_0016')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										<div>
											<span
												className={
													this.props.classes.link
												}
												data-careerid={
													row.original.careerId
												}
												data-careertype={
													row.original.careerType
												}
												onClick={
													this.handleShowDetailDialog
												}
											>
												{row.original.careerTitle}
											</span>
										</div>
									</div>
									<div className={classes.mobileCellItemName}>
										{i18next.t('Approvals_0018')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{row.original.classId === 'CL000000'
											? i18next.t(
													row.original.className,
													{
														ns: 'force',
													}
											  )
											: row.original.className}
									</div>
									<div className={classes.mobileCellItemName}>
										{i18next.t('Approvals_0019')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{this.getType(row)}
									</div>
									<div className={classes.mobileCellItemName}>
										{i18next.t('Approvals_0022')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{this.getDatePicker(row)}
									</div>
									<div className={classes.mobileCellItemName}>
										{i18next.t('Approvals_0023')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{row.original.target}
									</div>
									<div className={classes.mobileCellItemName}>
										{i18next.t('Approvals_0024')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{row.original.organizer}
									</div>
									{careerTypeControl === '1' && (
										<React.Fragment>
											<div
												className={
													classes.mobileCellItemName
												}
											>
												{i18next.t('Approvals_0025')}
											</div>

											<div
												className={
													classes.mobileCellItemValue
												}
											>
												{row.original.place}
											</div>
										</React.Fragment>
									)}
									<div className={classes.mobileCellItemName}>
										{i18next.t('Approvals_0026')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{row.original.cost}
									</div>
									<div className={classes.mobileCellItemName}>
										{i18next.t('Approvals_0027')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{row.original.status}
									</div>
									<div className={classes.mobileCellItemName}>
										{i18next.t('Approvals_0030')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{row.original.cancel === null ? (
											'---'
										) : (
											<Checkbox
												className={classes.checkbox}
												id="cancel"
												color="primary"
												data-index={row.index}
												onClick={this.onClickCancel}
												checked={!!row.original.cancel}
											/>
										)}
									</div>
									<div className={classes.mobileCellItemName}>
										{i18next.t('Approvals_0032')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{this.getApproverId1(row)}
									</div>
									<div className={classes.mobileCellItemName}>
										{i18next.t('Approvals_0033')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{this.getApproverId2(row)}
									</div>
									<div className={classes.mobileCellItemName}>
										{i18next.t('Approvals_0034')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{this.getApproverId4(row)}
									</div>
								</div>
							</Paper>
						</>
					);
				},
				minWidth: 140,
				required: true,
			},
		];
	}

	protected getApproverId4(row: RowRenderProps) {
		if (row.original.needApprove4 !== 1) {
			return i18next.t('Approvals_0031');
		}
		if (!row.original.approverList4) {
			return EMPTY_APPROVER_SELECT;
		}
		const defaultValue =
			(row.original.approverList4[0] &&
				row.original.approverList4[0].id) ||
			'';
		const value =
			row.original.approverId4 == null
				? defaultValue
				: row.original.approverId4;
		return (
			<Select
				id="approverId4"
				input={<Input name="approverId4" />}
				autoWidth={true}
				onChange={this.onChangeApprover}
				value={value}
				displayEmpty={true}
				classes={{
					selectMenu: this.props.classes.whiteSpace,
				}}
			>
				{row.original.approverList4.map(
					(approver: any, i: number): JSX.Element => (
						<MenuItem
							key={i}
							value={approver.id}
							data-index={row.index}
							className={this.props.classes.whiteSpaceMenuItem}
						>
							{i18next.t(approver.name, {
								ns: 'force',
							})}
						</MenuItem>
					)
				)}
			</Select>
		);
	}
	protected getApproverId2(row: RowRenderProps) {
		if (row.original.needApprove2 !== 1) {
			return i18next.t('Approvals_0031');
		}
		if (!row.original.approverList2) {
			return EMPTY_APPROVER_SELECT;
		}
		const defaultValue =
			(row.original.approverList2[0] &&
				row.original.approverList2[0].id) ||
			'';
		const value =
			row.original.approverId2 == null
				? defaultValue
				: row.original.approverId2;
		return (
			<Select
				id="approverId2"
				input={<Input name="approverId2" />}
				autoWidth={true}
				onChange={this.onChangeApprover}
				value={value}
				displayEmpty={true}
				classes={{
					selectMenu: this.props.classes.whiteSpace,
				}}
			>
				{row.original.approverList2.map(
					(approver: any, i: number): JSX.Element => (
						<MenuItem
							key={i}
							value={approver.id}
							data-index={row.index}
							className={this.props.classes.whiteSpaceMenuItem}
						>
							{i18next.t(approver.name, {
								ns: 'force',
							})}
						</MenuItem>
					)
				)}
			</Select>
		);
	}

	protected getApproverId1(row: RowRenderProps) {
		if (row.original.needApprove1 !== 1) {
			return i18next.t('Approvals_0031');
		}
		if (!row.original.approverList1) {
			return EMPTY_APPROVER_SELECT;
		}
		const defaultValue =
			(row.original.approverList1[0] &&
				row.original.approverList1[0].id) ||
			'';
		const value =
			row.original.approverId1 == null
				? defaultValue
				: row.original.approverId1;
		return (
			<Select
				id="approverId1"
				input={<Input name="approverId1" />}
				autoWidth={true}
				onChange={this.onChangeApprover}
				value={value}
				displayEmpty={true}
				classes={{
					selectMenu: this.props.classes.whiteSpace,
				}}
			>
				{row.original.approverList1.map(
					(approver: any, i: number): JSX.Element => (
						<MenuItem
							key={i}
							value={approver.id}
							data-index={row.index}
							className={this.props.classes.whiteSpaceMenuItem}
						>
							{i18next.t(approver.name, {
								ns: 'force',
							})}
						</MenuItem>
					)
				)}
			</Select>
		);
	}

	protected getType(row: RowRenderProps) {
		const careerType = row.original.careerType;
		const type = row.original.type;
		if (
			careerType === 0 ||
			careerType === 90 ||
			type === '資格' ||
			type === '業務経験' ||
			type === 'スキル診断'
		) {
			return i18next.t(type, { ns: 'force' });
		} else {
			return type;
		}
	}

	protected getDatePicker(row: RowRenderProps) {
		const { classes } = this.props;
		const careerType = Number(row.original.careerType);
		const careerTypeId = row.original.careerTypeId;
		const classId = row.original.classId;
		const endDateByYear = row.original.endDateByYear;
		const endDateByDay = row.original.endDateByDay;
		let period = row.original.period;
		if (period && period.indexOf('～') !== -1) {
			period = period.replace(
				'～',
				i18next.t('～', {
					ns: 'force',
				})
			);
		}
		if (careerType === 10 && classId === 'CL000000') {
			return (
				<div className={classes.mobileTextPeriod}>
					<CustomDatePicker
						name="startDate"
						value={this.state.startDate[row.index + '']}
						onChange={this.handleChangeStartDate(row.index)}
					/>
					<div
						style={{
							height: '35px',
							lineHeight: '35px',
							padding: '0px 4px',
						}}
					>
						{i18next.t('Approvals_0020')}
					</div>
					<CustomDatePicker
						name="endDate"
						value={this.state.endDate[row.index + '']}
						onChange={this.handleChangeEndDate(row.index)}
					/>
				</div>
			);
		} else if (
			careerType === 0 &&
			careerTypeId === 1 &&
			classId === 'CL000000' &&
			endDateByYear !== null
		) {
			return (
				<div className={classes.mobileTextPeriod}>
					{i18next.t('Approvals_0035', {
						endDateByYear,
					})}
				</div>
			);
		} else if (
			careerType === 0 &&
			careerTypeId === 1 &&
			classId === 'CL000000' &&
			endDateByDay !== null
		) {
			return (
				<div className={classes.mobileTextPeriod}>
					{i18next.t('Approvals_0036', {
						endDateByDay,
					})}
				</div>
			);
		} else {
			return <div className={classes.mobileTextPeriod}>{period}</div>;
		}
	}

	/**
	 * カラム表示制御
	 */
	protected getAllColumns() {
		const { classes } = this.props;
		const cmFlg: boolean = isValid(CMItemCode.CM_ENABLED);
		if (this.props.useFacilityFlg === 'Y') {
			return [
				{
					Cell: (row: RowRenderProps) => {
						return (
							<div>
								{row.original.check !== null && (
									<Checkbox
										className={this.props.classes.checkbox}
										data-index={row.index}
										checked={
											row.original.check === ''
												? true
												: false
										}
										onClick={this.check}
									/>
								)}
							</div>
						);
					},
					Header: (row: RowRenderProps) => {
						const selectable = this.props.data.filter(
							item => item.check === ''
						);
						const checked =
							selectable.length !== 0 &&
							selectable.length === this.props.data.length;
						return (
							<Checkbox
								className={this.props.classes.checkbox}
								checked={checked}
								color={'primary'}
								onClick={this.checkAll}
							/>
						);
					},
					accessor: 'check',
					required: true,
					sortable: false,
					width: 50,
				},
				{
					Header: i18next.t('Approvals_0014'),
					accessor: 'managementCode',
					minWidth: 100,
				},
				{
					Cell: (row: RowRenderProps) => {
						return (
							<span
								className={this.props.classes.link}
								data-careerid={row.original.careerId}
								data-careertype={row.original.careerType}
								onClick={this.handleShowDetailDialog}
							>
								{row.original.careerTitle}
							</span>
						);
					},
					Header: cmFlg
						? i18next.t('Approvals_0015')
						: i18next.t('Approvals_0016'),
					accessor: 'careerTitle',
					minWidth: 120,
				},
				{
					Cell: (row: RowRenderProps) =>
						row.original.classId === 'CL000000'
							? i18next.t(row.value, { ns: 'force' })
							: row.value,
					Header: cmFlg
						? i18next.t('Approvals_0017')
						: i18next.t('Approvals_0018'),
					accessor: 'className',
					minWidth: 110,
				},
				{
					Cell: (row: RowRenderProps) => {
						const careerType = row.original.careerType;
						const type = row.value;
						if (
							careerType === 0 ||
							careerType === 90 ||
							type === '資格' ||
							type === '業務経験' ||
							type === 'スキル診断'
						) {
							return i18next.t(type, { ns: 'force' });
						} else {
							return type;
						}
					},
					Header: i18next.t('Approvals_0019'),
					accessor: 'type',
					minWidth: 60,
				},
				{
					Cell: (row: RowRenderProps) => {
						const careerType = Number(row.original.careerType);
						const careerTypeId = row.original.careerTypeId;
						const classId = row.original.classId;
						const endDateByYear = row.original.endDateByYear;
						const endDateByDay = row.original.endDateByDay;
						let period = row.original.period;
						if (period && period.indexOf('～') !== -1) {
							period = period.replace(
								'～',
								i18next.t('～', {
									ns: 'force',
								})
							);
						}
						if (careerType === 10 && classId === 'CL000000') {
							return (
								<div className={classes.textPeriod}>
									<CustomDatePicker
										name="startDate"
										value={
											this.state.startDate[row.index + '']
										}
										onChange={this.handleChangeStartDate(
											row.index
										)}
									/>
									<div
										style={{
											height: '35px',
											lineHeight: '35px',
											padding: '0px 4px',
										}}
									>
										{i18next.t('Approvals_0020')}
									</div>
									<CustomDatePicker
										name="endDate"
										value={
											this.state.endDate[row.index + '']
										}
										onChange={this.handleChangeEndDate(
											row.index
										)}
									/>
								</div>
							);
						} else if (
							careerType === 0 &&
							careerTypeId === 1 &&
							classId === 'CL000000' &&
							endDateByYear !== null
						) {
							return (
								<div className={classes.textPeriod}>
									{i18next.t('Approvals_0035', {
										endDateByYear,
									})}
								</div>
							);
						} else if (
							careerType === 0 &&
							careerTypeId === 1 &&
							classId === 'CL000000' &&
							endDateByDay !== null
						) {
							return (
								<div className={classes.textPeriod}>
									{i18next.t('Approvals_0036', {
										endDateByDay,
									})}
								</div>
							);
						} else {
							return (
								<div className={classes.textPeriod}>
									{period}
								</div>
							);
						}
					},
					Header: cmFlg
						? i18next.t('Approvals_0021')
						: i18next.t('Approvals_0022'),
					accessor: 'period',
					maxWidth: 420,
					minWidth: 280,
				},
				{
					Header: i18next.t('Approvals_0023'),
					accessor: 'target',
					minWidth: 80,
				},
				{
					Header: i18next.t('Approvals_0024'),
					accessor: 'organizer',
					minWidth: 80,
				},
				{
					Header: i18next.t('Approvals_0025'),
					accessor: 'place',
					minWidth: 70,
				},
				{
					Header: i18next.t('Approvals_0026'),
					accessor: 'cost',
					minWidth: 80,
				},
				{
					Header: i18next.t('Approvals_0027'),
					accessor: 'status',
					minWidth: 80,
					sortable: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						if (
							row.original.stayMealFlg === false ||
							row.original.careerType === '1'
						) {
							return '---';
						}
						return (
							<Button
								variant="contained"
								color="primary"
								onClick={this.handleOpenStayMealDialog(row)}
							>
								{i18next.t('Approvals_0028')}
							</Button>
						);
					},
					Header: i18next.t('Approvals_0029'),
					accessor: 'stayMealFlg',
					minWidth: 80,
					sortable: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						if (row.original.cancel === null) {
							return '---';
						}
						return (
							<Checkbox
								className={classes.checkbox}
								id="cancel"
								color="primary"
								data-index={row.index}
								onClick={this.onClickCancel}
								checked={!!row.original.cancel}
							/>
						);
					},
					Header: i18next.t('Approvals_0030'),
					accessor: 'cancel',
					minWidth: 100,
					sortable: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						if (row.original.needApprove1 !== 1) {
							return i18next.t('Approvals_0031');
						}
						if (!row.original.approverList1) {
							return EMPTY_APPROVER_SELECT;
						}
						const defaultValue =
							(row.original.approverList1[0] &&
								row.original.approverList1[0].id) ||
							'';
						const value =
							row.original.approverId1 == null
								? defaultValue
								: row.original.approverId1;
						return (
							<Select
								id="approverId1"
								input={<Input name="approverId1" />}
								autoWidth={true}
								onChange={this.onChangeApprover}
								value={value}
								displayEmpty={true}
							>
								{row.original.approverList1.map(
									(approver: any, i: number): JSX.Element => (
										<MenuItem
											key={i}
											value={approver.id}
											data-index={row.index}
										>
											{i18next.t(approver.name, {
												ns: 'force',
											})}
										</MenuItem>
									)
								)}
							</Select>
						);
					},
					Header: i18next.t('Approvals_0032'),
					accessor: 'approverId1',
					minWidth: 100,
					sortable: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						if (row.original.needApprove2 !== 1) {
							return i18next.t('Approvals_0031');
						}
						if (!row.original.approverList2) {
							return EMPTY_APPROVER_SELECT;
						}
						const defaultValue =
							(row.original.approverList2[0] &&
								row.original.approverList2[0].id) ||
							'';
						const value =
							row.original.approverId2 == null
								? defaultValue
								: row.original.approverId2;
						return (
							<Select
								id="approverId2"
								input={<Input name="approverId2" />}
								autoWidth={true}
								onChange={this.onChangeApprover}
								value={value}
								displayEmpty={true}
							>
								{row.original.approverList2.map(
									(approver: any, i: number): JSX.Element => (
										<MenuItem
											key={i}
											value={approver.id}
											data-index={row.index}
										>
											{i18next.t(approver.name, {
												ns: 'force',
											})}
										</MenuItem>
									)
								)}
							</Select>
						);
					},
					Header: i18next.t('Approvals_0033'),
					accessor: 'approverId2',
					minWidth: 100,
					sortable: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						if (row.original.needApprove4 !== 1) {
							return i18next.t('Approvals_0031');
						}
						if (!row.original.approverList4) {
							return EMPTY_APPROVER_SELECT;
						}
						const defaultValue =
							(row.original.approverList4[0] &&
								row.original.approverList4[0].id) ||
							'';
						const value =
							row.original.approverId4 == null
								? defaultValue
								: row.original.approverId4;
						return (
							<Select
								id="approverId4"
								input={<Input name="approverId4" />}
								autoWidth={true}
								onChange={this.onChangeApprover}
								value={value}
								displayEmpty={true}
							>
								{row.original.approverList4.map(
									(approver: any, i: number): JSX.Element => (
										<MenuItem
											key={i}
											value={approver.id}
											data-index={row.index}
										>
											{i18next.t(approver.name, {
												ns: 'force',
											})}
										</MenuItem>
									)
								)}
							</Select>
						);
					},
					Header: i18next.t('Approvals_0034'),
					accessor: 'approverId4',
					minWidth: 100,
					sortable: false,
				},
			];
		} else {
			return [
				{
					Cell: (row: RowRenderProps) => {
						return (
							<div>
								{row.original.check !== null && (
									<Checkbox
										className={this.props.classes.checkbox}
										data-index={row.index}
										checked={
											row.original.check === ''
												? true
												: false
										}
										onClick={this.check}
									/>
								)}
							</div>
						);
					},
					Header: (row: RowRenderProps) => {
						const selectable = this.props.data.filter(
							item => item.check === ''
						);
						const checked =
							selectable.length !== 0 &&
							selectable.length === this.props.data.length;
						return (
							<Checkbox
								className={this.props.classes.checkbox}
								checked={checked}
								color={'primary'}
								onClick={this.checkAll}
							/>
						);
					},
					accessor: 'check',
					required: true,
					sortable: false,
					width: 50,
				},
				{
					Header: i18next.t('Approvals_0014'),
					accessor: 'managementCode',
					minWidth: 100,
				},
				{
					Cell: (row: RowRenderProps) => {
						return (
							<span
								className={this.props.classes.link}
								data-careerid={row.original.careerId}
								data-careertype={row.original.careerType}
								onClick={this.handleShowDetailDialog}
							>
								{row.original.careerTitle}
							</span>
						);
					},
					Header: cmFlg
						? i18next.t('Approvals_0015')
						: i18next.t('Approvals_0016'),
					accessor: 'careerTitle',
					minWidth: 120,
				},
				{
					Cell: (row: RowRenderProps) =>
						row.original.classId === 'CL000000'
							? i18next.t(row.value, { ns: 'force' })
							: row.value,
					Header: cmFlg
						? i18next.t('Approvals_0017')
						: i18next.t('Approvals_0018'),
					accessor: 'className',
					minWidth: 110,
				},
				{
					Cell: (row: RowRenderProps) => {
						const careerType = row.original.careerType;
						const type = row.value;
						if (
							careerType === 0 ||
							careerType === 90 ||
							type === '資格' ||
							type === '業務経験' ||
							type === 'スキル診断'
						) {
							return i18next.t(type, { ns: 'force' });
						} else {
							return type;
						}
					},
					Header: i18next.t('Approvals_0019'),
					accessor: 'type',
					minWidth: 60,
				},
				{
					Cell: (row: RowRenderProps) => {
						const careerType = Number(row.original.careerType);
						const careerTypeId = row.original.careerTypeId;
						const classId = row.original.classId;
						const endDateByYear = row.original.endDateByYear;
						const endDateByDay = row.original.endDateByDay;
						let period = row.original.period;
						if (period && period.indexOf('～') !== -1) {
							period = period.replace(
								'～',
								i18next.t('～', {
									ns: 'force',
								})
							);
						}
						if (
							careerType === 10 &&
							row.original.classId === 'CL000000'
						) {
							return (
								<div className={classes.textPeriod}>
									<CustomDatePicker
										name="startDate"
										value={
											this.state.startDate[row.index + '']
										}
										onChange={this.handleChangeStartDate(
											row.index
										)}
									/>
									<div
										style={{
											height: '35px',
											lineHeight: '35px',
											padding: '0px 4px',
										}}
									>
										{i18next.t('Approvals_0020')}
									</div>
									<CustomDatePicker
										name="endDate"
										value={
											this.state.endDate[row.index + '']
										}
										onChange={this.handleChangeEndDate(
											row.index
										)}
									/>
								</div>
							);
						} else if (
							careerType === 0 &&
							careerTypeId === 1 &&
							classId === 'CL000000' &&
							endDateByYear !== null
						) {
							return (
								<div className={classes.textPeriod}>
									{i18next.t('Approvals_0035', {
										endDateByYear,
									})}
								</div>
							);
						} else if (
							careerType === 0 &&
							careerTypeId === 1 &&
							classId === 'CL000000' &&
							endDateByDay !== null
						) {
							return (
								<div className={classes.textPeriod}>
									{i18next.t('Approvals_0036', {
										endDateByDay,
									})}
								</div>
							);
						} else {
							return (
								<div className={classes.textPeriod}>
									{period}
								</div>
							);
						}
					},
					Header: cmFlg
						? i18next.t('Approvals_0021')
						: i18next.t('Approvals_0022'),
					accessor: 'period',
					maxWidth: 420,
					minWidth: 280,
				},
				{
					Header: i18next.t('Approvals_0023'),
					accessor: 'target',
					minWidth: 80,
				},
				{
					Header: i18next.t('Approvals_0024'),
					accessor: 'organizer',
					minWidth: 80,
				},
				{
					Header: i18next.t('Approvals_0025'),
					accessor: 'place',
					minWidth: 70,
				},
				{
					Header: i18next.t('Approvals_0026'),
					accessor: 'cost',
					minWidth: 80,
				},
				{
					Header: i18next.t('Approvals_0027'),
					accessor: 'status',
					minWidth: 80,
					sortable: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						if (row.original.cancel === null) {
							return '---';
						}
						return (
							<Checkbox
								className={classes.checkbox}
								id="cancel"
								color="primary"
								data-index={row.index}
								onClick={this.onClickCancel}
								checked={!!row.original.cancel}
							/>
						);
					},
					Header: i18next.t('Approvals_0030'),
					accessor: 'cancel',
					minWidth: 100,
					sortable: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						if (row.original.needApprove1 !== 1) {
							return i18next.t('Approvals_0031');
						}
						if (!row.original.approverList1) {
							return EMPTY_APPROVER_SELECT;
						}
						const defaultValue =
							(row.original.approverList1[0] &&
								row.original.approverList1[0].id) ||
							'';
						const value =
							row.original.approverId1 == null
								? defaultValue
								: row.original.approverId1;
						return (
							<Select
								id="approverId1"
								input={<Input name="approverId1" />}
								autoWidth={true}
								onChange={this.onChangeApprover}
								value={value}
								displayEmpty={true}
							>
								{row.original.approverList1.map(
									(approver: any, i: number): JSX.Element => (
										<MenuItem
											key={i}
											value={approver.id}
											data-index={row.index}
										>
											{i18next.t(approver.name, {
												ns: 'force',
											})}
										</MenuItem>
									)
								)}
							</Select>
						);
					},
					Header: i18next.t('Approvals_0032'),
					accessor: 'approverId1',
					minWidth: 100,
					sortable: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						if (row.original.needApprove2 !== 1) {
							return i18next.t('Approvals_0031');
						}
						if (!row.original.approverList2) {
							return EMPTY_APPROVER_SELECT;
						}
						const defaultValue =
							(row.original.approverList2[0] &&
								row.original.approverList2[0].id) ||
							'';
						const value =
							row.original.approverId2 == null
								? defaultValue
								: row.original.approverId2;
						return (
							<Select
								id="approverId2"
								input={<Input name="approverId2" />}
								autoWidth={true}
								onChange={this.onChangeApprover}
								value={value}
								displayEmpty={true}
							>
								{row.original.approverList2.map(
									(approver: any, i: number): JSX.Element => (
										<MenuItem
											key={i}
											value={approver.id}
											data-index={row.index}
										>
											{i18next.t(approver.name, {
												ns: 'force',
											})}
										</MenuItem>
									)
								)}
							</Select>
						);
					},
					Header: i18next.t('Approvals_0033'),
					accessor: 'approverId2',
					minWidth: 100,
					sortable: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						if (row.original.needApprove4 !== 1) {
							return i18next.t('Approvals_0031');
						}
						if (!row.original.approverList4) {
							return EMPTY_APPROVER_SELECT;
						}
						const defaultValue =
							(row.original.approverList4[0] &&
								row.original.approverList4[0].id) ||
							'';
						const value =
							row.original.approverId4 == null
								? defaultValue
								: row.original.approverId4;
						return (
							<Select
								id="approverId4"
								input={<Input name="approverId4" />}
								autoWidth={true}
								onChange={this.onChangeApprover}
								value={value}
								displayEmpty={true}
							>
								{row.original.approverList4.map(
									(approver: any, i: number): JSX.Element => (
										<MenuItem
											key={i}
											value={approver.id}
											data-index={row.index}
										>
											{i18next.t(approver.name, {
												ns: 'force',
											})}
										</MenuItem>
									)
								)}
							</Select>
						);
					},
					Header: i18next.t('Approvals_0034'),
					accessor: 'approverId4',
					minWidth: 100,
					sortable: false,
				},
			];
		}
	}

	/**
	 * 選択カラム取得
	 */
	protected getSelectedColumns() {
		let columns: any[] = Object.assign([], this.getAllColumns());

		columns.map((column: any) => {
			if (column.required) {
				column.show = true;
			} else {
				column.show = false;
			}
		});

		if (this.props.useFacilityFlg === 'N') {
			this.props.selectedColumns.map((index: number) => {
				columns[index].show = true;
			});
		} else {
			this.props.selectedColumnsForStayMeal.map((index: number) => {
				columns[index].show = true;
			});
		}

		const careerTypeControl = getSystemMst(
			MasterItemCode.CAREER_TYPE_CONTROL
		);
		if (careerTypeControl === '0') {
			columns = columns.filter((column: any) => {
				return column.accessor !== 'place';
			});
		}

		return columns;
	}

	protected getSelectedMobileColumns() {
		const columns: any[] = Object.assign([], this.getAllMobileColumns());

		columns.map((column: any) => {
			column.show = true;
		});

		return columns;
	}

	/**
	 * カラム選択メニュー取得
	 */
	protected getSelectColumnsMenu() {
		const { classes } = this.props;
		let allColumns = this.getAllColumns();
		const careerTypeControl = getSystemMst(
			MasterItemCode.CAREER_TYPE_CONTROL
		);
		if (careerTypeControl === '0') {
			allColumns = allColumns.filter((column: any) => {
				return column.accessor !== 'place';
			});
		}
		const checkboxList: any[] = [];

		if (this.props.useFacilityFlg === 'N') {
			allColumns.map((column: any, index: number) => {
				if (!column.required) {
					checkboxList.push({
						checked:
							this.props.selectedColumns.indexOf(index) !== -1,
						index,
						text: column.Header,
					});
				}
			}, this);
		} else {
			allColumns.map((column: any, index: number) => {
				if (!column.required) {
					checkboxList.push({
						checked:
							this.props.selectedColumnsForStayMeal.indexOf(
								index
							) !== -1,
						index,
						text: column.Header,
					});
				}
			}, this);
		}

		return (
			<Menu
				id="select-column-menu"
				anchorEl={this.state.selectColumnsMenuAnchorEl}
				open={this.state.selectColumnsMenuAnchorEl ? true : false}
				onClose={this.handleCloseSelectColumns}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				transformOrigin={{ vertical: 'top', horizontal: 'center' }}
				getContentAnchorEl={undefined}
			>
				{checkboxList.map((checkboxItem, i) => {
					return (
						<MenuItem key={i}>
							<Checkbox
								id={checkboxItem.text}
								onChange={this.handleChangeCheckBox(
									checkboxItem
								)}
								checked={checkboxItem.checked}
							/>
							<InputLabel
								className={classes.pointer}
								htmlFor={checkboxItem.text}
							>
								{checkboxItem.text}
							</InputLabel>
						</MenuItem>
					);
				})}
			</Menu>
		);
	}

	/**
	 * 表示カラム選択ボタン
	 */
	protected handleSelectColumns = (event: React.MouseEvent<HTMLElement>) => {
		this.setState({
			selectColumnsMenuAnchorEl: event.currentTarget,
		});
	};

	/**
	 * 表示カラム選択メニュークローズ
	 */
	protected handleCloseSelectColumns = () => {
		this.setState({
			selectColumnsMenuAnchorEl: undefined,
		});
	};

	/**
	 * 表示カラム変更処理
	 */
	protected handleChangeCheckBox = (checkboxItem: any) => (
		event: React.ChangeEvent<HTMLInputElement>
	) => {
		if (this.props.useFacilityFlg === 'N') {
			const newSelectedColumns = Object.assign(
				[],
				this.props.selectedColumns
			);
			const idx = newSelectedColumns.indexOf(checkboxItem.index);

			if (event.target.checked) {
				if (idx === -1) {
					newSelectedColumns.push(checkboxItem.index);
				}
			} else {
				if (idx !== -1) {
					newSelectedColumns.splice(idx, 1);
				}
			}

			this.props.setApprovalsSelectedColumns(newSelectedColumns);
		}
		if (this.props.useFacilityFlg === 'Y') {
			const newSelectedColumns = Object.assign(
				[],
				this.props.selectedColumnsForStayMeal
			);
			const idx = newSelectedColumns.indexOf(checkboxItem.index);

			if (event.target.checked) {
				if (idx === -1) {
					newSelectedColumns.push(checkboxItem.index);
				}
			} else {
				if (idx !== -1) {
					newSelectedColumns.splice(idx, 1);
				}
			}

			this.props.setApprovalsSelectedColumnsForStayMeal(
				newSelectedColumns
			);
		}
	};

	protected closeDialog(event: React.MouseEvent<HTMLElement>) {
		this.props.openApprovals(false);
	}

	protected onClickCancel(event: React.MouseEvent<HTMLElement>) {
		const newApprovals = Object.assign([], this.props.data);
		const index = event.currentTarget.getAttribute('data-index');
		if (index && index !== '') {
			newApprovals[index].cancel = !newApprovals[index].cancel;
			this.props.setApprovals(newApprovals);
		}
	}

	protected onChangeApprover(event: React.ChangeEvent<HTMLSelectElement>) {
		const newApprovals = Object.assign([], this.props.data);
		const { name, value } = event.target;
		const index = event.currentTarget.getAttribute('data-index');
		if (name && name !== '' && index && index !== '') {
			newApprovals[index][name] = value;
			this.props.setApprovals(newApprovals);
		}
	}

	protected handleChangeStartDate = (index: number | undefined) => (
		name: string,
		dateStr: string
	) => {
		const newApprovals = Object.assign([], this.props.data);
		if (index !== undefined) {
			newApprovals[index + '']['startDate'] = dateStr
				? dateStr + ' ' + '00:00'
				: dateStr;
			const startDates = this.state.startDate;
			startDates[index + ''] = dateStr
				? dateStr + ' ' + '00:00'
				: dateStr;
			this.setState({ startDate: startDates });
			this.props.setApprovals(newApprovals);
		}
	};

	protected handleChangeEndDate = (index: number | undefined) => (
		name: string,
		dateStr: string
	) => {
		const newApprovals = Object.assign([], this.props.data);
		if (index !== undefined) {
			newApprovals[index + '']['endDate'] = dateStr
				? dateStr + ' ' + '23:59'
				: dateStr;
			const endDates = this.state.endDate;
			endDates[index + ''] = dateStr ? dateStr + ' ' + '23:59' : dateStr;
			this.setState({ endDate: endDates });
			this.props.setApprovals(newApprovals);
		}
	};

	protected onChangeReason(event: React.ChangeEvent<HTMLInputElement>) {
		this.setState({ reason: event.target.value });
	}

	protected applyCareers() {
		const { token } = this.props;

		const params = this.getParams();
		this.props.openApprovalConfirm(false);
		this.props.applyCareers(token, params);
	}

	private getParams(): IApplyCareersParam {
		const { data } = this.props;
		const selectable = data.filter(item => item.check === '');
		const { reason } = this.state;
		const stayMealData: IApprovalStayMealData[] = [];
		const tempStayMealList = JSON.parse(
			JSON.stringify(this.props.approvalStayMealList)
		);
		// const zone = new Date().getTimezoneOffset() * 60;
		// const zoneStr =
		// 	zone > 0
		// 		? '-' + this.formatSecToHHMM(Math.abs(zone))
		// 		: '+' + this.formatSecToHHMM(Math.abs(zone));
		// tslint:disable-next-line:prefer-for-of
		for (let xindex = 0; xindex < tempStayMealList.length; xindex++) {
			// tslint:disable-next-line:prefer-for-of
			for (let yindex = 0; yindex < selectable.length; yindex++) {
				if (
					tempStayMealList[xindex].careerID ===
						selectable[yindex].careerId &&
					tempStayMealList[xindex].classID ===
						selectable[yindex].classId
				) {
					stayMealData.push(tempStayMealList[xindex]);
				}
			}
		}
		let careerType = 0;
		const applies: IApply[] = selectable.map(
			(approval: IApprovalItem, index): IApply => {
				careerType = approval.careerType;
				if (careerType === 10) {
					return {
						approverId1: approval.approverId1,
						approverId2: approval.approverId2,
						approverId4: approval.approverId4,
						cancelWaitFlg: !!approval.cancel,
						careerId: approval.careerId,
						classId: approval.classId,
						endDate: this.state.endDate[index]
							.replace(/\-/g, '/')
							.replace(/\T/g, ' '),
						startDate: this.state.startDate[index]
							.replace(/\-/g, '/')
							.replace(/\T/g, ' '),
						stayMealData,
					};
				} else {
					return {
						approverId1: approval.approverId1,
						approverId2: approval.approverId2,
						approverId4: approval.approverId4,
						cancelWaitFlg: !!approval.cancel,
						careerId: approval.careerId,
						classId: approval.classId,
						stayMealData,
					};
				}
			}
		);

		return {
			applies,
			careerType,
			reason,
		};
	}

	// private formatSecToHHMM(sec: number): string {
	// 	const hourSec = 60 * 60;
	// 	const minuteSec = 60;
	// 	const hh = Math.floor(sec / hourSec)
	// 		.toString()
	// 		.padStart(2, '0');
	// 	const mm = Math.floor((sec % hourSec) / minuteSec)
	// 		.toString()
	// 		.padStart(2, '0');
	// 	if (Number(hh) > 0) {
	// 		return hh + ':' + mm;
	// 	} else if (Number(mm) > 0) {
	// 		return '00:' + mm;
	// 	} else {
	// 		return '00:00';
	// 	}
	// }

	private getDateFromStr(dateStr: string | null | undefined): string {
		let str = '';
		let dateObj: Date = new Date();
		const prefixZero = (num: number, n: number) => {
			return (Array(n).join('0') + num).slice(-n);
		};
		if (dateStr == null || dateStr === undefined) {
			return (
				prefixZero(Number(dateObj.getFullYear()), 4) +
				'-' +
				prefixZero(Number(dateObj.getMonth() + 1), 2) +
				'-' +
				prefixZero(Number(dateObj.getDate()), 2) +
				'T' +
				prefixZero(Number(dateObj.getHours()), 2) +
				':' +
				prefixZero(Number(dateObj.getMinutes()), 2)
			);
		}
		if (dateStr.length < 16) {
			return (
				prefixZero(Number(dateObj.getFullYear()), 4) +
				'-' +
				prefixZero(Number(dateObj.getMonth() + 1), 2) +
				'-' +
				prefixZero(Number(dateObj.getDate()), 2) +
				'T' +
				prefixZero(Number(dateObj.getHours()), 2) +
				':' +
				prefixZero(Number(dateObj.getMinutes()), 2)
			);
		} else {
			str = dateStr.substring(0, 16);
		}
		dateObj = new Date(str);
		return (
			prefixZero(Number(dateObj.getFullYear()), 4) +
			'-' +
			prefixZero(Number(dateObj.getMonth() + 1), 2) +
			'-' +
			prefixZero(Number(dateObj.getDate()), 2) +
			'T' +
			prefixZero(Number(dateObj.getHours()), 2) +
			':' +
			prefixZero(Number(dateObj.getMinutes()), 2)
		);
	}
}

const mapStateToProps = (state: IRootState) => ({
	approvalResult: state.search.approvalResult,
	approvalStayMealList: state.search.approvalStayMealList,
	canApproval: state.search.canApproval,
	classStayMealDialog: state.search.OpenClassStayMealDialog,
	data: state.search.approvals.data,
	isOpenApprovalConfirm: state.search.isOpenApprovalConfirm,
	isOpenApprovalResult: state.search.isOpenApprovalResult,
	isOpenCanApproval: state.search.isOpenCanApproval,
	searchCondition: state.search.careerSearchCondition,
	selectedColumns: state.search.approvals.selectedColumns,
	selectedColumnsForStayMeal:
		state.search.approvals.selectedColumnsForStayMeal,
	token: state.session.token,
	useFacilityFlg: state.search.useFacilityFlg,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	applyCareers: (token: string, arg: IApplyCareersParam) => {
		const s = ScenarioFactory.createApplyCareers(dispatch, token);
		s.run(arg);
	},
	closeCanApproval: () =>
		dispatch(
			setCanApproval({
				data: { messageId: '', replacementStringList: [] },
				isOpenCanApproval: false,
			})
		),
	fetchCanApproval: (token: string, arg: IApplyCareersParam) => {
		const s = ScenarioFactory.createFetchCanApproval(dispatch, token);
		s.run(arg);
	},
	fetchCategoryCareerTree: (token: string) => {
		const s = ScenarioFactory.createFetchCategoryCareerTree(
			dispatch,
			token
		);
		s.run({});
	},
	fetchDetailCareerList: (
		token: string,
		condition: ICareerSearchCondition
	) => {
		const s = ScenarioFactory.createFetchDetailCareerList(dispatch, token);
		s.run(condition);
	},
	fetchStayMealDateList: (token: string, arg: IStayMealSearchParam) => {
		const s = ScenarioFactory.FetchClassStayMealDateList(dispatch, token);
		s.run(arg);
	},
	openApprovalConfirm: (open: boolean) =>
		dispatch(openApprovalConfirm({ open })),
	openApprovalTargetCheck: (isOpenApprovalTargetCheck: boolean) =>
		dispatch(openApprovalTargetCheck({ isOpenApprovalTargetCheck })),
	openApprovals: (isOpenApprovals: boolean) =>
		dispatch(openApprovals({ isOpenApprovals })),
	pushHistory: (path: string) => dispatch(push(path)),
	setApprovalResult: (data: IApprovalResult, isOpenApprovalResult: boolean) =>
		dispatch(setApprovalResult({ data, isOpenApprovalResult })),
	setApprovals: (data: IApprovalItem[]) => dispatch(setApprovals({ data })),
	setApprovalsSelectedColumns: (selectedColumns: number[]) =>
		dispatch(setApprovalsSelectedColumns({ selectedColumns })),
	setApprovalsSelectedColumnsForStayMeal: (selectedColumns: number[]) =>
		dispatch(setApprovalsSelectedColumnsForStayMeal({ selectedColumns })),

	setApprovalStayMealList: (approvalStayMealList: IApprovalStayMealData[]) =>
		dispatch(setApprovalStayMealList({ approvalStayMealList })),
	setClassStayMealDialog: (OpenClassStayMealDialog: boolean) =>
		dispatch(setClassStayMealDialog({ OpenClassStayMealDialog })),
});

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & IApprovalsProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(Approvals);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/components/Approvals.tsx